import React from 'react';
import SEO from '../components/SEO/SEO';
import { BreadcrumbSchema } from '../components/SEO/StructuredData';
import ServicesPage from '../components/ServicesPage/ServicesPage';

function Services(): JSX.Element {
  return (
    <>
      <SEO title="Services" description="Explore Cool & Care's comprehensive services: IT security, CCTV, fire safety, HVAC, solar energy, and maintenance in DRC." keywords="IT security services, CCTV installation, fire safety, HVAC services, maintenance DRC" />
      <BreadcrumbSchema items={[{ name: 'Services', url: '/services' }]} />
      <ServicesPage />
    </>
  );
}

export default Services;
